module.exports = __webpack_public_path__ + "img/小图4.0d008f79.png";